"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimitiveCondition = void 0;
class PrimitiveCondition {
    constructor(type) {
        this.isOptional = false;
        this.isNullable = false;
        this.type = type;
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    optional() {
        this.isOptional = true;
        return this;
    }
    nullable() {
        this.isNullable = true;
        return this;
    }
    isFulfilled(value) {
        if (value === undefined) {
            if (this.isOptional) {
                return { fulfilled: true };
            }
            return { fulfilled: false, reasons: [{ path: "", value, explanation: "is undefined" }] };
        }
        if (value === null) {
            if (this.isNullable) {
                return { fulfilled: true };
            }
            return { fulfilled: false, reasons: [{ path: "", value, explanation: "is null" }] };
        }
        const type = typeof value;
        if (type !== this.type) {
            return { fulfilled: false, reasons: [{ path: "", value, explanation: `is a ${type}, but expected ${this.type}` }] };
        }
        return { fulfilled: true };
    }
}
exports.PrimitiveCondition = PrimitiveCondition;
//# sourceMappingURL=PrimitiveCondition.js.map